/**
 * La légende d'un graphique, bornée.
 *
 * ## Pourquoi
 *
 * Les légendes listaient **une entrée par ligne de données** : trente-deux navigateurs, cinquante
 * pages, douze appareils. La colonne du milieu s'étirait sur plusieurs écrans, repoussant le
 * camembert qu'elle était censée expliquer, et les trente dernières entrées désignaient des parts
 * invisibles à l'œil nu — un navigateur à une visite sur sept cent mille.
 *
 * Les tableaux s'arrêtent à dix lignes ; la légende suit la même règle.
 *
 * ## Ce qui n'est pas tronqué
 *
 * Ni le camembert, ni les totaux : seules les **étiquettes** sont bornées. Amputer les parts
 * fausserait les proportions, et un total calculé sur dix lignes serait faux sans le dire.
 *
 * Le reste est **compté et annoncé** — « + 22 autres ». Une liste qui s'arrête en silence se lit
 * comme une liste complète, et c'est précisément ce qu'on cherche à éviter : le lecteur doit
 * savoir qu'il voit un extrait.
 */

/** Dix entrées, comme les tableaux. */
export const LEGENDE_MAX = 10;

/**
 * Borne une légende et compte ce qui dépasse.
 *
 * @param {Array} entrees - La légende complète, dans l'ordre d'affichage voulu.
 * @param {number} [maximum] - Le plafond, dix par défaut.
 * @returns {{visibles: Array, reste: number}} Les entrées à rendre, et le nombre de laissées.
 */
export function bornerLegende(entrees, maximum = LEGENDE_MAX) {
  const liste = Array.isArray(entrees) ? entrees : [];
  return {
    visibles: liste.slice(0, maximum),
    reste: Math.max(0, liste.length - maximum)
  };
}

export default bornerLegende;
